{
  "title": "主機資源監控",
  "loading": "載入中",
  "disconnected": "未連線",
  "lastUpdate": "最後更新",
  "refresh": "重新整理",
  "days": "天",
  "free": "剩餘",
  "hostCpu": "整機 CPU 使用率",
  "hostMemory": "整機記憶體使用率",
  "diskFree": "磁碟剩餘空間",
  "uptime": "系統運行時間",
  "app": {
    "title": "本程式資源",
    "cpu": "程式 CPU 使用率",
    "memory": "程式記憶體用量",
    "memoryTip": "此為程序駐留於實體記憶體的「工作集」(含與系統共用的頁面)。與工作管理員的數值不一定相同：工作管理員「詳細資料」分頁顯示的是「作用中私用工作集」(已排除共用頁、且僅計作用中部分)，定義較窄，故數值通常較小；本欄與工作管理員「處理程序」分頁的記憶體較為接近。兩者皆正確，只是統計口徑不同。",
    "threads": "執行緒數"
  }
}